<template>
  <div class="role-manage-log">
    <app-query-bar
      :queryConfig="queryConfig"
      v-model="queryData"
      @onSearch="fetchLogs" />
    <app-export-bar
      @onExport="onExport"
      @onExportAll="onExportAll" />
    <app-data-table
      :columns="LOG_COLUMNS"
      :data="logs"
      v-model="queryData"
      @onPageConfigChange="fetchLogs">
      <template
        slot-scope="{ row }"
        slot="type">
        {{ BASIC_OPERATION_TYPE_TEXT[row.type] }}
      </template>
    </app-data-table>
  </div>
</template>

<script>
import {
  LOG_COLUMNS,
  OPERATION_TYPE,
  BASIC_OPERATION_TYPE_TEXT,
  OPERATION_TYPE_OPTIONS,
} from './constants';
import RoleManageLogApi from './role-manage-log.api';
import DataTransferUtil from '@/utils/data-transfer.util';

export default {
  name: 'role-manage-log',
  data() {
    return {
      LOG_COLUMNS,
      BASIC_OPERATION_TYPE_TEXT,
      queryConfig: [
        {
          fieldName: 'type',
          name: '操作类型',
          type: 'select',
          options: OPERATION_TYPE_OPTIONS,
        },
        {
          fieldName: 'optNickName',
          name: '操作人',
        },
      ],
      queryData: {
        page: 1,
        limit: 10,
        count: 0,
        type: OPERATION_TYPE.ALL,
        optNickName: '',
      },
      logs: [],
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      const {
        page,
        limit,
        type,
        optNickName,
      } = this.queryData;
      const {
        count = 0,
        results = [],
      } = await RoleManageLogApi.getLogs(
        page,
        limit,
        type,
        optNickName,
      );
      this.logs = results;
      this.$set(this.queryData, 'count', count);
    },
    async onExport() {
      const {
        page,
        limit,
        type,
        optNickName,
      } = this.queryData;
      const key = await RoleManageLogApi.export({
        page,
        limit,
        type,
        opt_nick_name: optNickName,
      });
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
    async  onExportAll() {
      const key = await RoleManageLogApi.export();
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
  },
};
</script>

<style scoped>

</style>
